
window.resizeFrame = function () {
    let userDisplayHeight = window.screen.height - (window.screen.height * .10);

    BX24.resizeWindow(window.innerWidth, userDisplayHeight);
};

/*
 * Уставналивает для фрейма width: 100%;
 */
function setFrameFlexible() {
    BX24.init(BX24.fitWindow);
}

setInterval(resizeFrame, 300);

window.addEventListener('load', function () {
    minHeight = bx24MinFrameHeight;
    /**
     * чтобы Херо работало, в самом начале окно надо уменьшить до минимума, иначе Херо примет размер такой,
     * какой был на предыдущей странице
     */
    BX24.resizeWindow(window.innerWidth, minHeight, setFrameFlexible);
});
